/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useState } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import identity from 'transmute/identity';
import I18n from 'I18n';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import { getId } from '../../../data/schemas/dashboardSchema';
import { useHideDialog } from '../../../dialog/ducks';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { DashboardUsedInAlertList } from '../../shared/dashboard-used-in/DashboardUsedInAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeleteReportsCheckbox = ({
  value,
  handleCheckboxChange
}) => {
  return /*#__PURE__*/_jsx(Checkbox, {
    checked: value,
    name: "removal option",
    onChange: handleCheckboxChange,
    marginBlockStart: "200",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reporting-action-components.actions.deleteDashboard.checkboxMessage`
    })
  });
};
const DeleteDashboardModal = ({
  dashboardsToDelete,
  appUsageTracker,
  filteredDashboardCount,
  onDelete = identity
}) => {
  const hide = useHideDialog();
  const usageTracker = useTracker(appUsageTracker);
  const [deleteReports, setDeleteReports] = useState(true);
  const handleCheckboxChange = () => {
    setDeleteReports(!deleteReports);
  };
  const count = dashboardsToDelete.isEmpty() ? filteredDashboardCount : dashboardsToDelete.size;
  const isBulk = count > 1;
  const deleteType = isBulk ? 'multi' : 'single';
  const name = !dashboardsToDelete.isEmpty() && dashboardsToDelete.first().get('name');
  const message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `reporting-action-components.actions.deleteDashboard.${deleteType}.message`,
    options: {
      name,
      count
    }
  });
  const match = isBulk ? `${count}` : null;
  const matchLabel = isBulk ? I18n.text('reporting-action-components.actions.deleteDashboard.multi.matcherLabel') : null;
  const onConfirm = () => {
    const dashboardIds = dashboardsToDelete.map(dashboard => getId(dashboard));
    const isMulti = dashboardIds.size > 1;
    if (usageTracker) {
      usageTracker.track(EVENTS.deleteDashboardNew, {
        subscreen: 'dashboard'
      });
    }
    // TODO: revisit to refactor logic if possible
    onDelete(dashboardIds, deleteReports).then(() => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isMulti ? 'reporting-action-components.actions.deleteDashboard.multi.successAlert' : 'reporting-action-components.actions.deleteDashboard.single.successAlert'
        }),
        type: 'success'
      });
    }, () => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isMulti ? 'reporting-action-components.actions.deleteDashboard.multi.failureAlert' : 'reporting-action-components.actions.deleteDashboard.single.failureAlert'
        }),
        type: 'danger'
      });
    });
    hide();
  };
  return /*#__PURE__*/_jsx(ConfirmModal, {
    "data-test-id": "dashboard-delete-modal",
    use: "danger",
    confirmUse: "danger",
    rejectUse: "tertiary-light",
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reporting-action-components.actions.deleteDashboard.${deleteType}.confirm`
    }),
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reporting-action-components.actions.deleteDashboard.cancel`
    }),
    message: message,
    description: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `reporting-action-components.actions.deleteDashboard.description`
      }), /*#__PURE__*/_jsx(DeleteReportsCheckbox, {
        value: deleteReports,
        handleCheckboxChange: handleCheckboxChange
      }), !dashboardsToDelete.isEmpty() && /*#__PURE__*/_jsx(DashboardUsedInAlertList, {
        dashboards: dashboardsToDelete.toJS()
      })]
    }),
    onConfirm: () => onConfirm({
      dashboards: dashboardsToDelete,
      deleteReports: handleCheckboxChange
    }),
    onReject: hide,
    size: "auto",
    match: match,
    matcherLabel: matchLabel
  });
};
DeleteDashboardModal.propTypes = {
  dashboardsToDelete: ImmutablePropTypes.set.isRequired,
  onDelete: PropTypes.func,
  filteredDashboardCount: PropTypes.number,
  appUsageTracker: PropTypes.object.isRequired
};
export default DeleteDashboardModal;